/**
 * @generated SignedSource<<0d3d0b3c2567883eed62f6c3200d2f4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type ValidateIntegrationInput = {
  credentials: string;
  integrationId?: any | null | undefined;
  integrationType: IntegrationType;
};
export type RollbarIntegrationFormValidateIntegrationMutation$variables = {
  input: ValidateIntegrationInput;
};
export type RollbarIntegrationFormValidateIntegrationMutation$data = {
  readonly validateIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type RollbarIntegrationFormValidateIntegrationMutation = {
  response: RollbarIntegrationFormValidateIntegrationMutation$data;
  variables: RollbarIntegrationFormValidateIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateIntegrationPayload",
    "kind": "LinkedField",
    "name": "validateIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RollbarIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RollbarIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "839b97217982ffb17c2fd1098dace2f8",
    "id": null,
    "metadata": {},
    "name": "RollbarIntegrationFormValidateIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation RollbarIntegrationFormValidateIntegrationMutation(\n  $input: ValidateIntegrationInput!\n) {\n  validateIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1c6df3165010a335b82a6ff761acbd7";

export default node;
